export default "__VITE_ASSET__d131c219__"